import moment from "moment";
const m = moment();

// The function converts the given timestamp to require timezone
export const convertUtcToTimeZone = (utcTimestamp, timeZone) => {
  if(!utcTimestamp){
    return "";
  }
    // display format options
    const options = {
      weekday: "short",
      day: "numeric",
      month: "short",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true
    };
  if(timeZone !== "" && timeZone !== undefined && timeZone!== null){
    //converting in given timezone
    const utcDate = new Date(utcTimestamp);
    const localDate = new Date(utcDate.toLocaleString("en-US", { timeZone }));
    let date = localDate.toLocaleString("en-US", options);
    // console.log("timezone local format ", m.tz(timeZone).format('z'))
    // returning the converted date with short form of timezone (Tue, Aug 29, 2023, 3:00:05 PM EDT)
    return date + " " + m.tz(timeZone).format('z');
  }
  else{
    // timezone is not available, then it convert to GMT
    const utcDate = new Date(utcTimestamp);
    const localDate = new Date(utcDate.toLocaleString("en-US", { timeZone: "UTC" }));
    let date = localDate.toLocaleString("en-US", options);
    return date + " GMT";
  }
}


// The function calculate the time ago..... like 2 hours ago
export const getTimeAgo = (timestamp) => {
    const currentTime = Date.now();
    const timeDifference = currentTime - timestamp;
    const seconds = Math.floor(timeDifference / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
  
    if (seconds < 60) {
      return `${seconds} seconds ago`;
    } else if (minutes < 60) {
      return `${minutes} minutes ago`;
    } else if (hours < 24) {
      return `${hours} hours ago`;
    } else {
      return `${days} days ago`;
    }
}